<label class="font-medium">Associated Quote Request</label>
<div
  class="flex items-center justify-between w-full bg-gradient-to-r from-primary-10 to-primary-40 dark:from-slate-800 dark:to-slate-700 rounded-lg p-3 border border-primary-200 dark:border-slate-600 shadow-sm hover:shadow-md transition-shadow duration-200">
  <a
    [href]="url"
    target="_blank"
    class="flex items-start flex-1 group dark:hover:bg-slate-600 rounded-md p-2 transition-colors duration-200">
    <div
      class="flex flex-col md:flex-row items-start md:items-center space-x-3 gap-1 md:gap-0">
      <span
        class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-slate-400 text-white shadow-sm">
        {{ quoteRequestTaskAssociation?.order_number }}
      </span>
      <mat-icon class="text-gray-400 hidden md:block dark:text-gray-500">
        chevron_right
      </mat-icon>

      <span class="text-md font-medium text-gray-900 dark:text-white">
        {{ quoteRequestTaskAssociation?.principal_name }}
      </span>

      <mat-icon class="text-gray-400 hidden md:block dark:text-gray-500">
        chevron_right
      </mat-icon>

      <span class="text-md text-gray-600 dark:text-gray-300">
        {{ quoteRequestTaskAssociation?.client_name }}
      </span>

      <mat-icon class="text-gray-400 hidden md:block dark:text-gray-500">
        chevron_right
      </mat-icon>

      <span class="text-md font-medium text-gray-700 dark:text-gray-200">
        {{ quoteRequestTaskAssociation?.bond_label }}
      </span>
    </div>
  </a>
  <div class="flex items-center ml-4">
    <button
      mat-icon-button
      class="!w-10 !h-10 !bg-primary-50 hover:!bg-primary-100 dark:!bg-primary-900/20 dark:hover:!bg-primary-800/30 !border !border-primary-200 dark:!border-primary-700 !shadow-sm hover:!shadow-md !transition-all !duration-200"
      (click)="onDetachQuoteRequestEvent()"
      matTooltip="Disassociate"
      matTooltipPosition="left">
      <mat-icon
        class="!text-primary-600 dark:!text-primary-400 !transition-colors !duration-200">
        link_off
      </mat-icon>
    </button>
  </div>
</div>
